import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

export const FullscreenDialogContainer = styled("div")({
    position: "fixed",
    left: 0,
    top: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 13000,
    display: "flex",
    flexDirection: "column",
});

export const FixedDialogContainer = styled("div")(() => {
    const width = Math.round(window.innerWidth * 0.8);
    const height = Math.round(window.innerHeight * 0.4);
    return {
        position: "fixed",
        left: 0,
        bottom: 0,
        zIndex: 13000,
        width,
        height,
        display: "flex",
        flexDirection: "column",
    };
});

export const StyledPaper = styled(Paper)({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
});

export const DragHandle = styled("div")({
    width: "100%",
    background: "#1976d2",
    color: "#fff",
    padding: "8px 16px",
    fontWeight: 600,
    letterSpacing: 1,
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
});

export const FullscreenButton = styled("button")({
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: 16,
    cursor: "pointer",
    marginRight: 8,
    padding: 0,
});

export const CloseButton = styled("button")({
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: 18,
    cursor: "pointer",
    marginLeft: 8,
    padding: 0,
});

export const DevtoolsContent = styled("div")({
    flex: 1,
    minHeight: 0,
    overflow: "auto",
});
